// extracted by mini-css-extract-plugin
export var hidden = "_pq-1";
export var visible = "_pq-0";